import React from "react"
import { useTranslation } from "react-i18next"
import { Sentry } from "@/telemetry/sentry"
import { Button } from "@/components/ui/Button"
import logoURL from "@assets/logo_pixieset_white.png?url"
import { useAuth } from "../../utils/auth"
import { getProductName } from "@/utils/product-name"
import { notifyAppReady } from "@/utils/electron"

/**
 * This component is shown to the user before they are logged in.
 * It is used in the Electron app to show a pre-login screen.
 */
export const ElectronPreLogin: React.FC = () => {
	const { t } = useTranslation("components")
	/**
	 * In Electron login redirects are intercepted and executed in the user's primary browser
	 */
	const { loginWithRedirect } = useAuth()

	const handleClickLogin = () => {
		loginWithRedirect({
			authorizationParams: {
				prompt: "login",
			},
			appState: {
				returnTo: window.location.pathname + window.location.search + window.location.hash,
			},
		}).catch(Sentry.captureException)
	}

	return (
		<div className="electron-drag flex size-full flex-col items-center justify-center bg-base-900">
			<img
				className="h-12 invert dark:invert-0"
				src={logoURL}
				alt={getProductName()}
				onLoad={() => notifyAppReady(APP_VERSION)}
			/>
			<div className="electron-no-drag absolute left-1/2 top-1/2 -translate-x-1/2 translate-y-14">
				<Button
					onClick={handleClickLogin}
					trackingLabel="login_electron"
					aria-label={t("electronPreLogin.ariaLogInToDesktopApp")}
					className="electron-no-drag"
					variant={"primary"}
					style={{
						animationName: "popIn",
						animationDuration: "0.5s",
						animationFillMode: "forwards",
					}}
				>
					{t("electronPreLogin.openBrowser")}
				</Button>
			</div>
		</div>
	)
}
